import React, { Component } from 'react'
import Badge from 'material-ui/Badge'
import { browserHistory } from 'react-router'
import { connect } from 'react-redux'
import { LOGOUT_REQUEST } from '../../actions/actions'
import { SIDEBAR_STATUS_TOGGLE } from '../../actions/actions'
import authSelector from '../../selectors/authSelector'
// import Notification from './Notification'
import { toPersianDigit } from '../../helpers/nums'
import ProfileDigestContainer from '../dashboard/ProfileDigestContainer'
import {isEmpty, equals} from 'ramda'
import { readSession } from '../../helpers/utility'
import LoggedInAs from './LoggedInAs'

const styles = {
  badgeStyle: {
    position: 'absolute',
    top: '-1px',
    right: '35px',
    padding: 0,
  },
  badgeNumber: {
    width: 18,
    height: 18,
    background: '#D81B60',
  },
}

class Header extends Component {
  constructor(props) {
    super(props)

    this.state = {
      asUser: undefined,
    }
  }

  componentDidMount() {
    const loggedInAs = readSession('fpAuth')
    const shouldSetState = !isEmpty(loggedInAs)
        && !equals(loggedInAs, this.state.asUser)

    if(shouldSetState) {
      this.setState({
        asUser: JSON.parse(loggedInAs)
      })
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    const loggedInAs = readSession('fpAuth')

    const shouldSetState = prevProps.userId !== this.props.userId
      && !isEmpty(loggedInAs)
        && !equals(loggedInAs, this.state.asUser)

    if(shouldSetState) {
      this.setState({
        asUser: JSON.parse(loggedInAs)
      })
    }
  }

  onLogOut = () => {
    this.props.dispatch({ type: LOGOUT_REQUEST })
  }

  onSidebarToggle = () => {
    this.props.dispatch({ type: SIDEBAR_STATUS_TOGGLE })
  }

  redirectTo = url => () => {
    browserHistory.push(url)
  }

  renderPendingOrderCount = (shouldShowPendingOrderBadge, pendingOrderCount) => {
    if (!shouldShowPendingOrderBadge || !pendingOrderCount) {
      return null
    }

    return (
      <Badge
        badgeContent={toPersianDigit(pendingOrderCount)}
        secondary={true}
        badgeStyle={styles.badgeNumber}
        style={styles.badgeStyle}
      />
    )
  }

  render() {
    const { pendingOrderCount, sidebarIsOpen, mobileView } = this.props
    const {asUser} = this.state

    const shouldShowPendingOrderBadge = !sidebarIsOpen || mobileView

    return (
      <div id="header">
        <div id="header-icons" className="nav-item">
          <div className="sub-nav-item" onClick={this.onSidebarToggle}>
            {this.renderPendingOrderCount(shouldShowPendingOrderBadge, pendingOrderCount)}
            <i className="fa fa-bars" aria-hidden="true" />
            <span className="sub-nav-text">منو</span>
          </div>

          {/* <div className="sub-nav-item" onClick={this.redirectTo('/dashboard')}>
            <i className="fa fa-home" aria-hidden="true" />
            <span className="sub-nav-text">خانه</span>
          </div> */}

          {/* <div
            className="sub-nav-item" // style={styles.supportLink}
            onClick={this.redirectTo('/dashboard/messages/compose')}
          >
            <i className="fa fa-phone" aria-hidden="true" />
            <span className="sub-nav-text">پشتیبانی</span>
          </div> */}

          {/* TODO: move support to somewhere else? */}
          {/* <div className="sub-nav-item">
            <Notification />
          </div> */}

          {/* {this.props.browser.greaterThan.medium &&
            <div
              className="sub-nav-item"
              onClick={this.onLogOut}
              style={styles.leftSideIcon}
            >
              <i className="fa fa-sign-out" aria-hidden="true" />
              <span className="sub-nav-text">خروج</span>
            </div>} */}
          {asUser && !isEmpty(asUser) && <LoggedInAs user={asUser} />}

          <div className="sub-nav-item">
            <ProfileDigestContainer />
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    ...authSelector(state),
    browser: state.browser,
    pendingOrderCount: state.profile.userInfo.pending_orders,
    sidebarIsOpen: state.sidebar.isOpen,
    mobileView: state.browser.lessThan.small,
  }
}

export default connect(mapStateToProps)(Header)



// WEBPACK FOOTER //
// ./src/components/common/Header.js